import _slicedToArray from "/home/circleci/project/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
export var useResponsive = function useResponsive(breakpoints) {
  var sizes = Object.entries(breakpoints).sort(function (_ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 2),
        a = _ref3[0],
        aSize = _ref3[1];

    var _ref4 = _slicedToArray(_ref2, 2),
        b = _ref4[0],
        bSize = _ref4[1];

    return bSize - aSize;
  });

  if (sizes[sizes.length - 1][1] !== 0) {
    console.warn('fixing', sizes[sizes.length - 1][0], 'size which should be 0');
    sizes[sizes.length - 1][1] = 0;
  }

  var getScreen = function getScreen() {
    var width = window.innerWidth;
    var size = sizes.find(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          _ = _ref6[0],
          size = _ref6[1];

      return size < width;
    })[0];
    var orientation = width > window.innerHeight ? 'landscape' : 'portrait';
    return {
      size: size,
      orientation: orientation,
      screenIsAtLeast: function screenIsAtLeast(breakpoint, andOrientation) {
        return width >= breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation);
      },
      screenIsAtMost: function screenIsAtMost(breakpoint, andOrientation) {
        return width <= breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation);
      }
    };
  };

  var _useState = useState(getScreen()),
      _useState2 = _slicedToArray(_useState, 2),
      screen = _useState2[0],
      setScreen = _useState2[1];

  useEffect(function () {
    var onResize = function onResize() {
      var current = getScreen();

      if (current.size !== screen.size || current.orientation !== screen.orientation) {
        setScreen(current);
      }
    };

    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [screen, setScreen, getScreen]);
  return screen;
};